import { get, post } from 'api/request'

export const API_ISSUE = "/project/service/issue"
export const API_PROJECT = "/project/service/project"

export const getIssueList = (contactKey, companyKey, goal, size = 20) => {
  let params = { 
    contact: contactKey, 
    company: companyKey,
    goal_type: goal, 
    offset: 0, 
    size,
  }
  return get(API_ISSUE, {urlParams: params})
}
export const getAllIssueList = (projectKey, offset = 0, size = 20, filters = {}, order) => {
  let params = { offset, size, project: projectKey }
  Object.keys(filters).forEach(k => {
    params[k] = filters[k]
  })
  if (order)
    params["order"] = order
  return get(API_ISSUE, { urlParams: params })
}
export const getAllIssueListMultiProject = (pks, offset = 0, size = 20, filters = {}, order) => {
  let params = { offset, size, projects: pks }
  Object.keys(filters).forEach(k => {
    params[k] = filters[k]
  })
  if (order)
    params["order"] = order
  return get(API_ISSUE, { urlParams: params })
}
export const createIssue = (projectKey, data={}) => post(
    `${API_ISSUE}`,
    { project: projectKey, ...data }
  )
export const getIssueDetail = (key) => get(`${API_ISSUE}/${key}`)
export const getProjectDetail = (key) => get(`${API_PROJECT}/${key}`)
